import { render, staticRenderFns } from "./SolicitudRenderer.vue?vue&type=template&id=53816c6c&scoped=true"
import script from "./SolicitudRenderer.vue?vue&type=script&lang=js"
export * from "./SolicitudRenderer.vue?vue&type=script&lang=js"
import style0 from "./SolicitudRenderer.vue?vue&type=style&index=0&id=53816c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53816c6c",
  null
  
)

export default component.exports